"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepIcon = StepIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function StepIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "#326ac2",
    r: "6"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "#fff",
    r: "4"
  }));
}